import { LandingVideo } from '../../../../components/_external-pages/landing/LandingVideo';

export const AboutVideo = () => {
  return <LandingVideo videoID={'zy9podrP0Q4'} />;
};
